import type { ChangeEvent } from 'react';
import { handleKeyPress, handlePaste } from './utils';

interface GradeInputColumnProps {
  testId?: string;
  value?: string; // A string of dd
  disabled?: boolean;
  label?: string;
  anchorId?: string;
  onChange?(value: string): void;
}

export default function GradeInputColumn({
  testId,
  value = '',
  disabled = false,
  label,
  anchorId,
  onChange,
}: GradeInputColumnProps) {

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(`${event.target.value}`);
  };

  return (
    <div className="govuk-date-input__item">
      <div className="govuk-form-group">
        <label className="govuk-label govuk-date-input__label" htmlFor={anchorId}>
          {label}
        </label>
        <input
          className="govuk-input govuk-date-input__input govuk-input--width-3"
          id={anchorId}
          data-testid={testId}
          type="number"
          value={value}
          onChange={handleChange}
          disabled={disabled ?? false}
          onKeyDown={(e) => handleKeyPress(e)}
          onPaste={(e) => handlePaste(e)}
          onFocus={(e) =>
            e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
          }
          style={{ backgroundColor: disabled ? '#b1b4b6' : 'transparent' }}
        />
      </div>
    </div>
  );
}
